/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */
export default function() {
	return [
		// Demonstrative pronouns:
		"bunlar", "şunlar", "onlar”, “burası", "orası", "şurası", "burayı", "orayı", "şurayı”, “buraya", "oraya", "şuraya”, “burada",
		"orada", "şurada”, “buradan", "oradan", "şuradan",
		// Demonstrative adjectives:
		"bu", "şu", "o",
		// Numbers:
		"bir", "íki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz", "on",
	];
}
